export function getChipColor(key) {
  // These colors line up with variables in quasar.variables.scss file.
  const colorLookup = {
    meeting_incentive: 'blue-1',
    event_link: 'blue-1',
    asset_download: 'blue-1',
    active: 'teal-12',
    available: 'cyan-4',
    paused: 'purple-2',
    archived: 'amber-11',
    draft: 'blue-11',
    private: 'red-11',
    published: 'deep-purple-3',
    campaign_available: 'cyan-4',
    campaign_available_dot: 'cyan-8',
    campaign_launched: 'green-11',
    campaign_launched_dot: 'green-14',
    campaign_paused: 'yellow-2',
    campaign_paused_dot: 'yellow-8',
    campaign_ended: 'red-2',
    campaign_ended_dot: 'red-8',
    campaign_approved: 'light-blue-2',
    campaign_approved_dot: 'light-blue-8',
    campaign_archived_dot: 'grey-7',
    campaign_draft: 'orange-2',
    campaign_draft_dot: 'orange-8'
  }
  return colorLookup[key]
}

export function stringToTitleCase(str) {
  return str.replace(/^_*(.)|_+(.)/g, (s, c, d) => c ? c.toUpperCase() : ' ' + d.toUpperCase())
}

export function calculateLeadMetrics(leadMetrics = {}) {
  // sample lead metrics from API:
  // {
  //   "bad-lead__account-targeting-no-fit": 2,
  //   "bad-lead__bad-contact-info": 17,
  //   "bad-lead__job-title-no-fit": 3,
  //   "deal-registered__lead-deal-registered": 9,
  //   "in-progress__waiting-to-hear-back": 81,
  //   "meeting-stage__meeting-booked": 9,
  //   "meeting-stage__meeting-held-conversation": 9,
  //   "meeting-stage__meeting-held-nurture": 9,
  //   "meeting-stage__not-good-fit": 3
  // }
  // There will probably be no need for this function in the future once we clean up the back-end.
  const metrics = {
    leads: 0,
    meetings: 0,
    deals: 0,
  }
  for (const key in leadMetrics) {
    metrics.leads += leadMetrics[key]
    if (key.includes('Deal Registered')) {
      metrics.deals += leadMetrics[key]
      // Any lead that is an deal state should also be counted as a meeting.
      metrics.meetings += leadMetrics[key]
    }
    else if (key.includes('Meeting Stage')) {
      metrics.meetings += leadMetrics[key]
    }
  }
  return metrics
}
